document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".cb-wrapper").forEach((banner) => {

    const timer = banner.querySelector(".cb-timer");

    if (!timer) return;

    const days = banner.querySelector(".days");
    const hours = banner.querySelector(".hours");
    const minutes = banner.querySelector(".minutes");
    const seconds = banner.querySelector(".seconds");

    const endDate = timer.dataset.date;
    const endTime = timer.dataset.time;

    const targetDate = new Date(`${endDate} ${endTime}`).getTime();

    function updateTimer() {

      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {

        days.textContent = "00";
        hours.textContent = "00";
        minutes.textContent = "00";
        seconds.textContent = "00";

        clearInterval(interval);

        return;
      }

      const d = Math.floor(distance / (1000 * 60 * 60 * 24));

      const h = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const m = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      const s = Math.floor(
        (distance % (1000 * 60)) /
        1000
      );

      days.textContent = String(d).padStart(2, "0");
      hours.textContent = String(h).padStart(2, "0");
      minutes.textContent = String(m).padStart(2, "0");
      seconds.textContent = String(s).padStart(2, "0");
    }

    updateTimer();

    const interval = setInterval(updateTimer, 1000);

    const closeBtn = banner.querySelector(".cb-close");

    if (closeBtn) {

      closeBtn.addEventListener("click", () => {

        banner.style.display = "none";

      });

    }

  });

});